<template>
  <div>
    <a-modal v-model="visible" :confirmLoading="loading" :maskClosable="false" @cancel="cancel" @ok="confirm">
      <div slot="title">{{ form.id ? "充值会员" : "充值会员" }}</div>
      <div>
        <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
          <a-form-model-item prop="p_user_name" label="客户名称">
            <a-input v-model="form.p_user_name" />
          </a-form-model-item>
          <a-form-model-item prop="member" label="会员类型">
            <a-select v-model="form.member"  allowClear style="width: 100%;">
              <a-select-option v-for="item in roleItems" :key="item.id" :value="item.id">{{item.name}}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { memberBuyCreate, memberBuyUpdate } from "@/api/member";
import { settlementAccountCreate, settlementAccountUpdate } from "@/api/basic";
export default {
  name: "FormModal",
  props: ["visible", "form",'roleItems'],  //, "clientsClassificationOptions"
  model: { prop: "visible", event: "cancel" },
  data () {
    return {
      levelOptions: [
        { id: "0", name: "普通客户" },
        { id: "1", name: "初级VIP客户" },
        { id: "2", name: "中级VIP客户" },
        { id: "3", name: "高级VIP客户" },
        { id: "4", name: "尊贵VIP客户" },
      ],
      rules: {
        name: [
          { required: true, message: "请输入名称", trigger: "change" },
          { max: 64, message: "超出最大长度 (64)", trigger: "change" },
        ],
        number: [
          { required: true, message: "请输入编号", trigger: "change" },
          { max: 32, message: "超出最大长度 (32)", trigger: "change" },
        ],
        //initial_arrears_amount: [
        //  { pattern: new RegExp(/^\d{0,14}(?:\.\d{0,2})?$/), message: "初期欠款金额格式不正确", trigger: "change" },
        //],
      },
      loading: false,
    };
  },
  methods: {
    confirm () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          let func = this.form.id ? memberBuyUpdate : memberBuyCreate;
          func(this.form)
            .then((data) => {
              if (data.code==0){
              this.$message.success(this.form.id ? "充值成功" : "充值成功");
              this.$emit(this.form.id ? "update" : "create", data);
              this.cancel();
              this.$parent.list();
              }else{
                this.$message.error(data.msg)
              }
            })
            .finally(() => {
              this.loading = false;
            });
          //let func1 = this.form.id ? settlementAccountUpdate : settlementAccountCreate;
          //func1(this.form)
          //  .then((data) => {
          //    this.$message.success(this.form.id ? "充值成功" : "充值成功");
          //    this.$emit(this.form.id ? "update" : "create", data);
          //    this.cancel();
          //  })
          //  .finally(() => {
          //    this.loading = false;
          //  });
        }
      });
    },
    cancel () {
      this.$emit("cancel", false);
      this.$refs.form.resetFields();
    },
  },
};
</script>

<style scoped></style>
